<template>
  <div class="col-sm-12">
    <div class="card">
      <div class="dropdown-item page-item">
        <div class="page-grid">

          <template v-if="!isDistributorUser">
            <div class="page-search-container dropdown-item">
              <div style="display: flex; align-items: center; gap: 10px;">
                <label for="distributor" style="font-weight:700; white-space: nowrap;">Distributor : </label>
                <select
                    id="distributor"
                    v-model="selectedDistributor"
                    class="scrollable-dropdown select-distributor"
                    @change="getRoutes"
                >
                  <option value="">All Distributors</option>
                  <option v-for="distributor in distributorList" :key="distributor.profile_id" :value="distributor.profile_id">
                    {{ distributor.name }}
                  </option>
                </select>
              </div>
            </div>

            <div class="page-search-container dropdown-item">
              <input
                  type="text"
                  placeholder="Search routes by name, start/end point"
                  class="search-input"
                  v-model="searchFilter"
              />
            </div>

            <button type="button" class="btn button-default" @click="addNewRoute">
              Add New Route
            </button>
          </template>

          <template v-else>
            <div class="page-search-container dropdown-item">
              <input
                  type="text"
                  placeholder="Search routes by name, start/end point"
                  class="search-input"
                  v-model="searchFilter"
              />
            </div>

            <button type="button" class="btn button-default" @click="addNewRoute">
              Add New Route
            </button>
          </template>
        </div>
      </div>

      <div v-if="loading" class="loading-spinner mt-3">
        <i class="fa fa-spinner fa-spin"></i> Loading...
      </div>

      <div v-if="!loading && routeList.length > 0" class="table-container">
        <table>
          <thead>
          <tr>
            <th>Route Name</th>
            <th>Start Point</th>
            <th>End Point</th>
            <th>Distance (Km.)</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="route in filteredRoutes" :key="route.id">
            <td :title="route.route_name">
              {{ truncateText(route.route_name, 15) }}
            </td>
            <td :title="route.start_point">
              {{ truncateText(route.start_point, 15) }}
            </td>
            <td :title="route.end_point">
              {{ truncateText(route.end_point, 15) }}
            </td>
            <td>{{ route.distance }}</td>
            <td>
              <span
                  class="status-badge"
                  :class="{
                    active: route.is_active === '1',
                    inactive: route.is_active === '0',
                  }"
              >
                {{ route.is_active === '1' ? 'Active' : 'Inactive' }}
              </span>
            </td>

            <td>  
              <i class="fa fa-edit" @click="editRoute(route.id)" title="Edit"></i>
              <i class="fa fa-eye action-icon" aria-hidden="true" @click="viewRoute(route.id)" title="View"></i>
            </td>
          </tr>

          <tr v-if="filteredRoutes.length === 0">
            <td colspan="6" class="text-center">
              <span v-if="!loading">No routes found matching your criteria.</span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <!-- Show No Data Found Component  -->
      <div v-if="!loading && routeList.length === 0" class="not-found-widget">
        <img src="../../../assets/vectors//data_not_found.png" alt="No Routes" class="error-image" />
        <p class="text-center error-message">Routes Not Found!</p>
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import { fetchDistributorsList, fetchRoutesList} from "@/services/dataService";

export default {
  name: 'RouteList',
  data() {
    return {
      loading: false,
      token: localStorage.getItem("token_set") || "",
      profileId: localStorage.getItem("profile_id"),
      reportingProfileId: localStorage.getItem("reportingL1ProfileId"),
      userCategory: localStorage.getItem("user_label"),
      
      searchFilter: "",
      selectedDistributor: "", 
      isDistributorUser: false,
      
      distributorList: [],
      routeList: [],
    }
  },
  computed: {
    filteredRoutes() {
      let filterDistId = "";

      if (this.isDistributorUser) {
        filterDistId = this.userCategory === 'DISTRIBUTOR BACK OFFICE' ? this.reportingProfileId : this.profileId;
      } else {
        filterDistId = this.selectedDistributor;
      }

      return this.routeList.filter(route => {
        const matchesDistributor = filterDistId ? (String(route.distributor_id) === String(filterDistId)) : true;

        const searchTerm = this.searchFilter.toLowerCase();
        const matchesSearch = 
            (route.route_name || '').toLowerCase().includes(searchTerm) ||
            (route.start_point || '').toLowerCase().includes(searchTerm) ||
            (route.end_point || '').toLowerCase().includes(searchTerm);

        return matchesDistributor && matchesSearch;
      });
    }
  },
  methods: {
    // Helper to truncate long strings
    truncateText(text, length) {
      if (!text) return '';
      if (text.length <= length) return text;
      return text.substring(0, length) + '...';
    },

    // Fetch Distributors List
    async fetchDistributors() {
      try {
        const response = await fetchDistributorsList(this.profileId, this.token);
        this.distributorList = response.data.data || [];
      } catch (error) {
        console.error('Error fetching Distributors:', error);
      }
    },

    // Fetch Routes List
    async getRoutes() {
      try {
        this.loading = true;
        let idToUse = "";
        if (this.isDistributorUser) {
          idToUse = this.userCategory === 'DISTRIBUTOR BACK OFFICE' ? this.reportingProfileId : this.profileId;
        } else {
          idToUse = this.selectedDistributor || this.profileId;
        }

        const response = await fetchRoutesList(this.token, idToUse);
        
        if (response.data && response.data.data && response.data.data.routes) {
          this.routeList = response.data.data.routes;
        } else {
          this.routeList = [];
        }
      } catch (error) {
        console.error("Error fetching route list:", error);
        this.routeList = [];
      } finally {
        this.loading = false;
      }
    },

    // Navigate to Create Route Page
    addNewRoute() {
      this.$router.push('/create-route');
    },

    // Navigate to Edit Route Page
    editRoute(id) {
      this.$router.push({
        path: '/edit-route',
        query: { routeId: id }   // pass as query param
      });
    },

    // Navigate to View Route Page
    viewRoute(id) {
      this.$router.push({
        path: '/view-route',
        query: { routeId: id }   // pass as query param
      });
    },

    // Initialize User Settings
    initializeUserSettings() {
      const userLabel = localStorage.getItem("user_label");
      this.isDistributorUser = userLabel === "DISTRIBUTOR" || userLabel === "DISTRIBUTOR BACK OFFICE";

      if (userLabel === "DISTRIBUTOR") {
        this.selectedDistributor = this.profileId;
      } else if (userLabel === "DISTRIBUTOR BACK OFFICE") {
        this.selectedDistributor = this.reportingProfileId;
      }
    }
  },
  setup() {
    const router = useRouter();
    return { router };
  },
  mounted() {
    this.getRoutes();
    if (!this.isDistributorUser) {
      this.fetchDistributors();
    }
    this.initializeUserSettings();
  }
};
</script>

<style scoped> 
.page-grid {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 15px;
}

.page-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}

.page-search-container {
  display: flex;
  align-items: center;
  flex-grow: 1;
}

.page-search-container.dropdown-item {
  flex-grow: 0;
  flex-basis: auto;
}

.search-input {
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px;
  transition: border-color 0.3s, box-shadow 0.3s;
  width: 100%;
  min-width: 250px;
}

.search-input:hover {
  border-color: #0056b3;
}

.new-item-btn {
  margin-left: auto;
  padding: 10px 20px;
  white-space: nowrap;
  flex-shrink: 0;
}

.select-distributor {
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px;
  transition: border-color 0.3s, box-shadow 0.3s;
  min-width: 250px;
}

.select-distributor:hover {
  border-color: #0056b3;
}

.card {
  padding: 10px;
}

.loading-spinner {
  font-size: 18px;
  text-align: center;
  margin-top: 20px;
  color: #007bff;
}

.table-container {
  width: 100%;
  overflow-x: auto;
}

table {
  width: 100%;
  min-width: 800px;
  border-collapse: collapse;
  margin: 10px 0;
  border: none;
}

th {
  text-align: left;
  border-bottom: 2px solid #ddd;
  background-color: #f4f4f4;
  padding: 10px;
  white-space: nowrap;
}

td {
  text-align: left;
  border: none;
  padding: 10px;
  white-space: nowrap;
  border-bottom: 1px solid #eee;
}

tbody tr:last-child td {
  border-bottom: none;
}

.icon-button {
  margin: 0;
  font-size: 15px;
  background-color: transparent;
  border: none;
}

.fa-eye {
  cursor: pointer;
  transition: color 0.3s, transform 0.3s;
  margin-left: 5px;
}

.fa-eye:hover {
  color: #0056b3;
  transform: scale(1.2);
}

.fa-eye:active {
  transform: scale(1.1);
}

.fa-edit {
  cursor: pointer;
  transition: color 0.3s, transform 0.3s;
}

.fa-edit:hover {
  color: #0056b3;
  transform: scale(1.2);
}

.fa-edit:active {
  transform: scale(1.1);
}

.status-badge {
  display: inline-block;
  padding: 4px 10px;
  font-size: 13px;
  border-radius: 5px;
  text-align: center;
  width: 100px;       
  max-width: 100px;   
  min-width: 100px; 
  color: #fff;
  box-sizing: border-box;
}

.status-badge.active {
  background-color: #069E27;
}

.status-badge.inactive {
  background-color: #c62828;
}

.not-found-widget {
  display: flex;           
  flex-direction: column;  
  align-items: center;     
  justify-content: center; 
  margin: 50px auto;       
  width: 100%;             
  max-width: 500px;        
}

.not-found-widget img {
  width: 250px;
}

.not-found-widget p {
  color: grey;
  font-size: 18px;
  font-weight: bold;
  margin-top: -25px;
}

input:focus, select:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(38, 143, 255, 0.5);
  outline: none;
}

@media (max-width: 768px) {
  .page-grid {
    flex-direction: column;
    gap: 10px;
    align-items: stretch;
  }

  .page-search-container {
    width: 100%;
  }

  .search-input, .select-distributor {
    min-width: 100%;
  }

  .new-item-btn {
    margin-left: 0;
    width: 100%;
  }
}
</style>